import axios from 'axios'
import { setSetupIntegration, getSetupIntegration } from '@/utils/auth.js'

const getDefaultState = () => {
  return {
    gaIntegration: null,
    gaIsSetup: false,
    gaShow: false
  }
}

// initial state
const state = getDefaultState()

const actions = {
  loadGAIntegration ({ commit }, domain) {
    return axios({
      url: `${domain}/integrations/google_analytics`
    })
    .then((response) => {
      commit('setIntegrations', response.data)
      commit('setIsSetup', response.data.is_setup)

      if (response.data.name === getSetupIntegration()) {
        commit('gaSetShow', true)
        setSetupIntegration(null)
      }
    })
    .catch((error) => {
      console.log(error)
    })
  }
}

// mutations
const mutations = {
  setIntegrations (state, integration) {
    state.gaIntegration = integration
  },
  setIsSetup (state, isSetup) {
    state.gaIsSetup = isSetup
  },
  gaSetShow (state, bool) {
    state.gaShow = bool
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/js/store/modules/ga.js